import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Cell, OeeSettings, OeeSettingsClient } from "../../../../../backend/backendapi";
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import { WindowType } from "../../../../../../util";
import { initClient } from "../../../../../../api";

declare var window: WindowType;

@Component({
    name: 'OeeTab',
    components: {
        VueGoodTable,
    },
})
export default class OeeTab extends Vue {
    @Prop({ required: true })
    private readonly cell!: Cell | undefined;

    //api
    private oeeApi = initClient(OeeSettingsClient);

    //runtime
    private readonly settings: OeeSettings[] = [];

    //config
    private readonly columnsConfig = [
        {
            label: 'Db',
            field: (e: OeeSettings) => e.ignDb,
        },
        {
            label: 'Table',
            field: (e: OeeSettings) => e.ignTable,
        },
        {
            label: 'Field',
            field: (e: OeeSettings) => e.ignFieldValue,
        },
        {
            label: '',
            field: 'actions'
        },
    ];

    //mount
    async mounted(): Promise<void> {
        await this.reloadAll();
    }

    //data
    private reloadAll(): Promise<void> {
        return this.reloadOeeSettings();
    }

    private async reloadOeeSettings(): Promise<void> {
        let settings = await this.oeeApi.getCellsData();
        console.log(settings);
        this.settings.splice(0);
        this.settings.push(...settings);
    }

    //computed
    private get cellSettings(): OeeSettings[] {
        if (!this.cell?.id) {
            return [];
        }
        return this.settings.filter(d => d.fkCellId === this.cell!.id);
    }

    //event handler
    private gotoOeeSetting(setting: OeeSettings): void {
        window.location.href = "quick/oeeconfig?oeesetting=" + setting.id;//TODO this is bad, what if the component is mounted somewhere else?
    }
}